import React, { useEffect } from "react";
import { Fade, Slide } from "react-awesome-reveal";

import { Link } from "react-router-dom";
import coupleImg1 from "../../images/couple/4.jpg";
import coupleImg2 from "../../images/couple/5.jpg";
import SectionTitle from "../SectionTitle";
import { connect } from "react-redux";
import { getHashtag, replaceString } from "../../utils/string";
import { welcomeMessageTitle } from "../../utils/constant";
import { capitalize } from "@mui/material";
import Hashtag from "../Hashtag/Hashtag";
import coupleImg4 from "../../images/couple/right-invitee.svg";
import { getCloudinaryFullPath } from "../../utils";
import CoupleHeading from "../CoupleHeading/CoupleHeading";
import CoupleInfo from "../CoupleInfo/CoupleInfo";

const CoupleSection4 = ({ bride = {}, groom = {}, isFromPortfolio }) => {
  return (
    <section
      className="wpo-couple-section-s4 section-padding section"
      id="couple"
    >
      <Slide
        direction="up"
        // delay={200} // Wait before starting
        duration={1000}
        triggerOnce
      >
        <div className="container-fluid">
          <CoupleHeading />
          <Hashtag />
          <div className="couple-area clearfix">
            <div className="row align-items-center">
              <div className="col col-xl-3 col-lg-4 col-12">
                <Slide direction="up" duration={1000} triggerOnce>
                  <div className="text-grid">
                    <CoupleInfo data={bride} isGroom={false} />
                    {/* <div className="social">
                  <ul>
                    <li>
                      <Link to="/home3">
                        <i className="ti-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home3">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home3">
                        <i className="ti-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </Slide>
              </div>
              <div
                className="col col-xl-6 col-lg-4 col-12"
                style={{ zIndex: 1 }}
              >
                <div className="middle-couple-pic-wrap">
                  <div className="middle-couple-pic">
                    <Slide direction="left" duration={1000} triggerOnce="true">
                      <div className="middle-couple-pic-inner">
                        <img
                          className="zoom"
                          src={getCloudinaryFullPath(bride?.photo)}
                          alt=""
                        />
                      </div>
                    </Slide>
                  </div>
                  <div className="middle-couple-pic">
                    <Slide direction="right" duration={1000} triggerOnce="true">
                      <div className="middle-couple-pic-inner">
                        <img
                          className="zoom"
                          src={getCloudinaryFullPath(groom?.photo)}
                          alt=""
                        />
                      </div>
                    </Slide>
                  </div>
                </div>
              </div>
              <div className="col col-xl-3 col-lg-4 col-12">
                <Slide direction="up" duration={1000} triggerOnce>
                  <div className="text-grid">
                    <CoupleInfo data={groom} isGroom={true} />
                    {/* <div className="social">
                  <ul>
                    <li>
                      <Link to="/home3">
                        <i className="ti-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home3">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/home3">
                        <i className="ti-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </Slide>
              </div>
            </div>
          </div>
        </div>
      </Slide>
      <div className="right-shape">
        <img src={coupleImg4} alt="" />
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    bride: state.inviteDetails.invite?.bride,
    groom: state.inviteDetails.invite?.groom,
    isFromPortfolio: state.common?.isFromPortfolio,
  };
};

export default connect(mapStateToProps)(CoupleSection4);
